import PcFixed from './PcFixed'

const directives = { PcFixed }

export default {
  install(app: any) {
    Object.keys(directives).forEach((key) => {
      app.directive(key, directives[key])
    })
  },
}
